import React from "react";
import AnimatedCol from "../../../../components/AnimatedCol";
import EinbindungInFundament from "../LageKopfplatteUndUbergangsrohr/EinbindungInFundament";
import Einbindelaenge_in_Baugrund from "../LageKopfplatteUndUbergangsrohr/Einbindelaenge_in_Baugrund";
import DurchmesserUebergangsrohr from "./DurchmesserUebergangsrohr";
import LaengeUebergangsrohr from "./LaengeUebergangsrohr";
import WanddickeUebergangsrohr from "./WanddickeUebergangsrohr";
import { useTranslation } from "react-i18next";
import { selectTragglied } from "../../../../store/slices/traggliedSlice";
import { useGetTraggliedDatenQuery } from "../../../../services/API/titanApi";
import { useSelector } from "react-redux";

function BestimmungDesUebergangsrohres({
  durchmesserDesRohres,
  wanddickeUebergangsrohr,
  einbindelaengeBaugrund,
  laenge,
}) {
  const { t } = useTranslation("translation");

  const tragglied = useSelector(selectTragglied);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);

  return (
    <div className="row">
      <div className="col-md-12">
        <h3>{t("aeussre.minDimensionPositionTransitionPipe")}</h3>
      </div>

      <AnimatedCol>
        <DurchmesserUebergangsrohr D={durchmesserDesRohres} />
      </AnimatedCol>

      <AnimatedCol>
        <WanddickeUebergangsrohr wanddickeUebergangsrohr={wanddickeUebergangsrohr} />
      </AnimatedCol>

      <AnimatedCol>
        <EinbindungInFundament
          einbindung_fundament={traggliedDaten?.kopfkonstruktion?.einbindung_fundament}
        />
      </AnimatedCol>

      <AnimatedCol>
        <Einbindelaenge_in_Baugrund einbindelaenge_in_baugrund={einbindelaengeBaugrund} />
      </AnimatedCol>

      <AnimatedCol>
        <LaengeUebergangsrohr value={Number(laenge)} />
      </AnimatedCol>
    </div>
  );
}

export default BestimmungDesUebergangsrohres;
